var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonaManLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 258.73 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #212529;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,1.07H13.89l6.7,28.14h.11L27.62,1.07h13.73V38.94h-8.94V9.52h-.11l-7.5,29.41h-8.35L8.73,9.52h-.1v29.41H0V1.07ZM0,1.07"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.79,7.98c-5.54,0-9.69,3.51-9.69,12.02,0,5.54,2.23,12.02,9.69,12.02,7.02,0,9.69-6.17,9.69-12.02s-2.66-12.02-9.69-12.02m0,32.02c-12.08,0-19.16-9.36-19.16-20S50.71,0,62.79,0s19.16,9.36,19.16,20-7.08,20-19.16,20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.44,1.07h9.58l13.78,24.2h.11V1.07h8.62V38.94h-9.47l-13.89-23.83h-.11v23.83h-8.62V1.07Zm0,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.9,25.96l-4.68-15.64h-.11l-4.68,15.64h9.47ZM131.17,1.07h9.79l14.32,37.87h-10.17l-1.91-5.96h-14l-1.92,5.96h-10.11L131.17,1.07Zm0,0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.94,1.07h4.42l12.29,31.7h.11L191.05,1.07h4.42V38.94h-3.62V7.98h-.11l-11.81,30.96h-2.45l-11.82-30.96h-.1v30.96h-3.62V1.07Zm0,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.68,24.57l-7.03-18.67-7.24,18.67h14.27Zm-5.38-23.51l14.69,37.87h-3.88l-4.26-11.38h-16.66l-4.52,11.38h-3.73L211.38,1.07h2.92Zm0,0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.78,1.07h3.56l21.66,31.81h.1V1.07h3.62V38.94h-3.56l-21.66-31.81h-.11v31.81h-3.62V1.07Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonaManLogo);
export default __webpack_public_path__ + "static/media/MonaMan Logo.b2a81eb676080fc43534ebe8193386a5.svg";
export { ForwardRef as ReactComponent };